import {
  getReq,
  // postReq,
  // deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'

// const baseUrl = process.env.BASE_URL

const state = {
  assignInfo: {
    accountant: '',
    accountantName: '',
    accountantOn: new Date(0),
    cashier: '',
    cashierName: '',
    cashierOn: new Date(0),
    checker: '',
    checkerName: '',
    checkerOn: new Date(0),
    othUserList: [], // userId, userName, assignOn
    othUserIdList: [], // userId
    othUserNameList: [], // userName
    costCtrlUserList: [], // userId, userName, assignOn
    costCtrlUserIdList: [], // userId
    costCtrlUserNameList: [], // userName
    // status: '',
    // crtBy: '',
    // crtOn: new Date(0),
    // updBy: '',
    // updOn: new Date(0),
    //
    indUsed: ''
  },
  END_STATE: null
}

const getters = {

}

const actions = {
  async assignProjectAccountant({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    let projectInfo = {
      accountant: state.assignInfo.accountant,
      //
      projId: projId,
      compId: compId
    }
    const updateObject = await putReq(END_POINTS.ASSIGN_RSP_PROJECT_ACCOUNTANT, {
      data: projectInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async assignProjectCashier({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    let projectInfo = {
      cashier: state.assignInfo.cashier,
      //
      projId: projId,
      compId: compId
    }
    const updateObject = await putReq(END_POINTS.ASSIGN_RSP_PROJECT_CASHIER, {
      data: projectInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async assignProjectChecker({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    let projectInfo = {
      checker: state.assignInfo.checker,
      //
      projId: projId,
      compId: compId
    }
    const updateObject = await putReq(END_POINTS.ASSIGN_RSP_PROJECT_CHECKER, {
      data: projectInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async assignProjectOthUser({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    let othUserList = []
    if (state.assignInfo.othUserIdList) {
      (state.assignInfo.othUserIdList || []).forEach(userId => {
        othUserList.push({userId})
      })
    }
    let projectInfo = {
      // othUserIdList: state.assignInfo.othUserIdList,
      othUserList,
      //
      projId: projId,
      compId: compId
    }
    const updateObject = await putReq(END_POINTS.ASSIGN_RSP_PROJECT_OTH_USER, {
      data: projectInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async assignProjectCostCtrlUser({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    let costCtrlUserList = []
    if (state.assignInfo.costCtrlUserIdList) {
      (state.assignInfo.costCtrlUserIdList || []).forEach(userId => {
        costCtrlUserList.push({userId})
      })
    }
    let projectInfo = {
      // costCtrlUserIdList: state.assignInfo.costCtrlUserIdList,
      costCtrlUserList,
      //
      projId: projId,
      compId: compId
    }
    const updateObject = await putReq(END_POINTS.ASSIGN_RSP_PROJECT_COST_CTRL_USER, {
      data: projectInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async findRspProjAssignFinance({
    commit
  }, {projId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_RSP_PROJECT_ASSIGN_FINANCE + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateAssignInfo', responseData.data)
    } else {
      commit('updateAssignInfo', {})
    }
  },
  END_ACTIONS() {}
}

const mutations = {
  //
  updateAccountant(state, value) {
    state.assignInfo.accountant = value
  },
  updateAccountantOn(state, value) {
    state.assignInfo.accountantOn = value
  },
  updateCashier(state, value) {
    state.assignInfo.cashier = value
  },
  updateCashierOn(state, value) {
    state.assignInfo.cashierOn = value
  },
  updateChecker(state, value) {
    state.assignInfo.checker = value
  },
  updateCheckerOn(state, value) {
    state.assignInfo.checkerOn = value
  },
  updateOthUserIdList(state, value) {
    state.assignInfo.othUserIdList = value
  },
  updateCostCtrlUserIdList(state, value) {
    state.assignInfo.costCtrlUserIdList = value
  },
  // updateProjectListObject(state, projectListObject) {
  //   if (projectListObject.code === 2001) {
  //     state.projectListObject.projectList = projectListObject.data.map(value => {
  //       return {
  //         projId: value.projId,
  //         projName: value.projName,
  //         projDesc: value.projDesc,
  //         compId: value.compId,
  //         projMgr: value.projMgr,
  //         projStatus: value.projStatus,
  //         startDt: value.startDt,
  //         endDt: value.endDt,
  //         accountantTo: value.accountantTo,
  //         accountantOn: value.accountantOn,
  //         cashierTo: value.cashierTo,
  //         cashierOn: value.cashierOn,
  //         status: value.status,
  //         crtBy: value.crtBy,
  //         crtOn: value.crtOn,
  //         updBy: value.updBy,
  //         updOn: value.updOn,
  //         //
  //         indUsed: value.indUsed
  //       }
  //     })
  //     state.projectListObject.currentPage = projectListObject.currentPage
  //     state.projectListObject.pageSize = projectListObject.pageSize
  //     state.projectListObject.total = projectListObject.total
  //     state.projectListObject.totalPage = projectListObject.totalPage
  //   } else {
  //     state.projectListObject.projectList = []
  //     state.projectListObject.total = 0
  //   }
  // },
  updateAssignEmpty(state) {
    state.assignInfo.accountant = ''
    state.assignInfo.accountantName = ''
    state.assignInfo.accountantOn = new Date(0)
    state.assignInfo.cashier = ''
    state.assignInfo.cashierName = ''
    state.assignInfo.cashierOn = new Date(0)
    state.assignInfo.othUserList = []
    state.assignInfo.othUserIdList = []
    state.assignInfo.othUserNameList = []
    state.assignInfo.costCtrlUserList = []
    state.assignInfo.costCtrlUserIdList = []
    state.assignInfo.costCtrlUserNameList = []
  },
  updateAssignInfo(state, assignInfo) {
    // debugger
    state.assignInfo.accountant = assignInfo.accountant
    state.assignInfo.accountantName = assignInfo.accountantName
    state.assignInfo.accountantOn = assignInfo.accountantOn
    state.assignInfo.cashier = assignInfo.cashier
    state.assignInfo.cashierName = assignInfo.cashierName
    state.assignInfo.cashierOn = assignInfo.cashierOn
    state.assignInfo.checker = assignInfo.checker
    state.assignInfo.checkerName = assignInfo.checkerName
    state.assignInfo.checkerOn = assignInfo.checkerOn
    state.assignInfo.othUserList = assignInfo.othUserList
    state.assignInfo.costCtrlUserList = assignInfo.costCtrlUserList
    if (state.assignInfo.othUserList && state.assignInfo.othUserList.length) {
      let userIdList = []
      let userNameList = []
      state.assignInfo.othUserList.forEach(user => {
        userIdList.push(user.userId)
        userNameList.push(user.userName)
      })
      state.assignInfo.othUserIdList = userIdList
      state.assignInfo.othUserNameList = userNameList
    } else {
      state.assignInfo.othUserIdList = []
      state.assignInfo.othUserNameList = []
    }
    if (state.assignInfo.costCtrlUserList && state.assignInfo.costCtrlUserList.length) {
      let userIdList = []
      let userNameList = []
      state.assignInfo.costCtrlUserList.forEach(user => {
        userIdList.push(user.userId)
        userNameList.push(user.userName)
      })
      state.assignInfo.costCtrlUserIdList = userIdList
      state.assignInfo.costCtrlUserNameList = userNameList
    } else {
      state.assignInfo.costCtrlUserIdList = []
      state.assignInfo.costCtrlUserNameList = []
    }
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/rspProjAssignManage.js